<a id="nav-top"></a>

<div class="assessment-container">
  
  <app-error-message></app-error-message>
  
  <app-progress-bar 
    [selectedForm]="selectedForm!"
    [showOptions]="wasLoaded" 
    (onOptions)="onOptions()">
  </app-progress-bar>
  
  @if (!notificationService.hasError) {
    <form id="assessmentForm" name="assessmentForm" role="form" autocomplete="off" novalidate #assessmentForm="ngForm">
      <div class="content-container">
        <ng-container #dynamicComponent></ng-container>
      </div>
     

    </form>
    
    @if(saveResultMessage){
      <div  class="mat-elevation-z2 alert-container" [ngClass]="{
              'alert-success': saveResultMessageType === 'success',
              'alert-error': saveResultMessageType === 'error',
              'fade-out': fadeOutAlert && saveResultMessageType === 'success'
            }">
    {{ saveResultMessage }}
    <button mat-icon-button aria-label="Dismiss" (click)="saveResultMessage = null"
      style="position: absolute; top: 8px; right: 8px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

@defer (when isComponentReady && getCurrentPageComponent()) {
  <app-button-bar
    [currentPageIndex]="getCurrentPageIndex()"
    [currentPageComponent]="getCurrentPageComponent()!"
    (onSave)="onSave()"
    (onSubmit)="onSubmit()"
    [validate]="true"
    >
  </app-button-bar>
}

  }
</div>